<template>
  <div id="held-options-group">
    <LabelReset v-model="held" :initialValue="initialHeld"> Status </LabelReset>
    <RadioInput
      v-for="option in heldOptions"
      :key="`help-option-${option}`"
      radioName="held_options_radio"
      :value="option"
      v-model="held"
      :label="option"
      :uid="`radio-held-${option}`"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'

import LabelReset from '@/common/components/molecules/LabelReset.vue'
import RadioInput from '@/common/components/molecules/RadioInput.vue'

type HeldOption = (typeof HELD_OPTIONS)[keyof typeof HELD_OPTIONS]
const HELD_OPTIONS = {
  AVAILABLE: 'available',
  HELD: 'held',
}
const heldOptions = Object.values(HELD_OPTIONS)

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (e: 'update:modelValue', value: boolean): void
}>()

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    initialValue?: boolean
  }>(),
  {
    initialValue: undefined,
  },
)
const { modelValue, initialValue } = toRefs(props)

const held = computed<HeldOption>({
  get() {
    return modelValue.value ? HELD_OPTIONS.HELD : HELD_OPTIONS.AVAILABLE
  },
  set(value) {
    emit('update:modelValue', value === HELD_OPTIONS.HELD)
  },
})

const initialHeld = computed(() => {
  if (initialValue.value === undefined) return undefined
  return initialValue.value ? HELD_OPTIONS.HELD : HELD_OPTIONS.AVAILABLE
})
</script>
